export enum ModuleCodeEnum {
    JuvOffice = 'OFFICE',
    JuvAdmin = 'ADMIN',
}